import type {
    GetDisclosureContentRequest,
    GetDisclosureContentResponse,
    GetDisclosureTitleRequest,
    GetTechMeansRequest,
    GoalSettings,
    GoalSettingWithRecommend,
    PutTechMeansRequest,
    ExportDisclosureRequest,
    GetContentStorageRequest,
    GetContentStorageResponse,
} from '@/services/ai-disclosure/type/ai-disclosure.type';
import type { SSEStreamService } from '@patsnap-utils/sse';
import type { HistoryDetail } from '@/services/history/type/history.type';

export const ExportDisclosureDTO = Symbol('ExportDisclosureDTO');

export interface ExportDisclosureDTO {
    fetch: (value: ExportDisclosureRequest) => Promise<string>;
}

export const GetDisclosureContentDTO = Symbol('GetDisclosureContentDTO');

export interface GetDisclosureContentDTO {
    fetch: (value: GetDisclosureContentRequest) => SSEStreamService<GetDisclosureContentResponse>;
}

export const GetDisclosureTitleDTO = Symbol('GetDisclosureTitleDTO');

export interface GetDisclosureTitleDTO {
    fetch: (value: GetDisclosureTitleRequest) => Promise<string>;
}

export const GetTechMeansDTO = Symbol('GetTechMeansDTO');

export interface GetTechMeansDTO {
    fetch: (value: GetTechMeansRequest) => Promise<GoalSettingWithRecommend>;
}

export const PutDisclosureSettingDTO = Symbol('PutDisclosureSettingDTO');

export interface PutDisclosureSettingDTO {
    fetch: (value: GoalSettings & { taskId: string, currentStep: string }) => Promise<void>;
}

export const InitDisclosureSettingDTO = Symbol('InitDisclosureSettingDTO');

export interface InitDisclosureSettingDTO {
    fetch: (value: GoalSettings & { taskId: string, currentStep: string }) => Promise<void>;
}

export const PutTechMeansDTO = Symbol('PutTechMeansDTO');

export interface PutTechMeansDTO {
    fetch: (value: PutTechMeansRequest) => Promise<GoalSettingWithRecommend>;
}

export const GetDisclosureHistoryDetailDTO = Symbol('GetDisclosureHistoryDetailDTO');

export interface GetDisclosureHistoryDetailDTO {
    fetch: (taskId: string) => Promise<HistoryDetail>;
}

export const GetContentStorageDTO = Symbol('GetContentStorageDTO');

export interface GetContentStorageDTO {
    fetch: (params: GetContentStorageRequest) => Promise<GetContentStorageResponse>;
}
